import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

function FrContent() {
  return (
    <>
      <section>
        <p className="text-slate-600">
          Cartonomie respecte votre vie privée et applique le Règlement Général sur la Protection des
          Données (RGPD — UE 2016/679) ainsi que la loi française « Informatique et Libertés ».
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement est l'éditeur de Cartonomie. Pour toute question relative à vos
          données, contactez :{" "}
          <a href="mailto:privacy@cartonomie.fr" className="text-[#E11D48] underline">privacy@cartonomie.fr</a>.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">2. Données collectées</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Compte</strong> : adresse e-mail, mot de passe haché (bcrypt), nom d'affichage, langue préférée, devise.</li>
          <li><strong>Collection</strong> : cartes Pokémon que vous marquez comme possédées ou favorites.</li>
          <li><strong>Activité</strong> : pages consultées, recherches effectuées, alertes de prix configurées.</li>
          <li><strong>Technique</strong> : adresse IP (anonymisée par hachage), user-agent, date de visite.</li>
          <li><strong>Paiement</strong> (Premium uniquement) : géré exclusivement par Stripe, aucune donnée bancaire stockée par Cartonomie.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">3. Finalités &amp; bases légales</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Exécution du contrat</strong> : créer et maintenir votre compte, gérer votre collection.</li>
          <li><strong>Intérêt légitime</strong> : mesurer l'audience (statistiques anonymes via Plausible), prévenir les abus.</li>
          <li><strong>Consentement</strong> : envoi d'alertes de prix, cookies non essentiels.</li>
          <li><strong>Obligation légale</strong> : conservation des données de facturation pour le Premium.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">4. Durée de conservation</h2>
        <p>
          Vos données sont conservées tant que votre compte est actif. À la suppression du compte, les
          données personnelles sont effacées sous 30 jours. Les données de facturation sont conservées
          10 ans (obligation comptable). Les statistiques de visite anonymisées sont conservées 25 mois.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">5. Destinataires &amp; sous-traitants</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>MongoDB / Emergent</strong> — hébergement de la base de données (UE).</li>
          <li><strong>Stripe</strong> — gestion des paiements Premium (Irlande/USA, certifié RGPD).</li>
          <li><strong>APIs publiques de données cartes</strong> (pokemontcg.io, tcgdex.dev) — aucune donnée personnelle n'est partagée.</li>
        </ul>
        <p className="text-xs text-slate-500 mt-2">
          Aucun outil d'analyse tiers (Google Analytics, Facebook Pixel, etc.) n'est utilisé.
          Les statistiques d'audience sont calculées en interne sur des données anonymisées.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">6. Vos droits</h2>
        <p>Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Droit d'accès, de rectification, d'effacement</li>
          <li>Droit à la limitation et à l'opposition au traitement</li>
          <li>Droit à la portabilité de vos données</li>
          <li>Droit de retirer votre consentement à tout moment</li>
          <li>Droit d'introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" className="text-[#E11D48] underline">cnil.fr</a>)</li>
        </ul>
        <p className="mt-2">
          Pour exercer ces droits, écrivez à{" "}
          <a href="mailto:privacy@cartonomie.fr" className="text-[#E11D48] underline">privacy@cartonomie.fr</a>{" "}
          ou utilisez la fonction « Supprimer mon compte » depuis votre tableau de bord.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">7. Sécurité</h2>
        <p>
          Mots de passe hachés avec bcrypt, communication chiffrée TLS, accès restreint à la base de
          données, journaux d'audit. En cas de violation de données, vous serez informé sous 72h
          conformément à l'article 34 RGPD.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">8. Cookies</h2>
        <p>
          Voir notre <a href="/cookies" className="text-[#E11D48] underline">Politique cookies</a> dédiée.
        </p>
      </section>
    </>
  );
}

function EnContent() {
  return (
    <>
      <section>
        <p className="text-slate-600">
          Cartonomie respects your privacy and complies with the EU GDPR (2016/679).
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Data we collect</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Account</strong>: email, hashed password (bcrypt), display name, language, currency.</li>
          <li><strong>Collection</strong>: cards you mark as owned or favorited.</li>
          <li><strong>Activity</strong>: pages viewed, searches, price alerts.</li>
          <li><strong>Technical</strong>: hashed IP, user-agent.</li>
          <li><strong>Payments</strong> (Premium): handled exclusively by Stripe.</li>
        </ul>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Your rights</h2>
        <p>
          Access, rectify, erase, restrict, port your data, withdraw consent or lodge a complaint with
          your local DPA. Contact{" "}
          <a href="mailto:privacy@cartonomie.fr" className="text-[#E11D48] underline">privacy@cartonomie.fr</a>.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Processors</h2>
        <p>MongoDB / Emergent (hosting, EU), Stripe (payments, GDPR-certified). No third-party trackers — analytics are computed internally on anonymized data.</p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Cookies</h2>
        <p>See our <a href="/cookies" className="text-[#E11D48] underline">Cookie policy</a>.</p>
      </section>
    </>
  );
}

export default function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const isFr = (i18n.language || "en").toLowerCase().startsWith("fr");
  return (
    <LegalLayout
      testId="privacy-policy-page"
      title={isFr ? "Politique de confidentialité" : "Privacy policy"}
      subtitle={isFr
        ? "Comment Cartonomie collecte, utilise et protège vos données personnelles."
        : "How Cartonomie collects, uses and protects your personal data."}
      lastUpdated={isFr ? "Mise à jour · Février 2026" : "Updated · February 2026"}
    >
      {isFr ? <FrContent /> : <EnContent />}
    </LegalLayout>
  );
}
